import { useMemo } from "react";

export default function useDialogCopy({ entityLabel, mode, entity }) {
    return useMemo(() => {
        const name = entity?.name;
        const COPY = {
            create: {
                title: `Add New ${entityLabel}`,
                yesLabel: "Save",
                yesVariant: "primary",
            },
            edit: {
                title: `Edit ${entityLabel}`,
                yesLabel: "Save",
                yesVariant: "primary",
            },
            delete: {
                title: "Confirm Deletion",
                subtitle: `Are you sure you want to delete the geographic unit '${name || entityLabel}'? This action cannot be undone.`,
                yesLabel: "Delete",
                yesVariant: "danger",
            },
        };
        return COPY[mode] || COPY.create;
    }, [entityLabel, mode, entity]);
}
